// extracted by mini-css-extract-plugin
module.exports = {"bb-impact-stats__wrapper":"bb-impact-stats__wrapper__8L0gg","bb-impact-stats":"bb-impact-stats__pQ6qr"};